import { render, staticRenderFns } from "./BuyNow.vue?vue&type=template&id=21b32166&functional=true&"
import script from "./BuyNow.vue?vue&type=script&lang=js&"
export * from "./BuyNow.vue?vue&type=script&lang=js&"
import style0 from "./BuyNow.vue?vue&type=style&index=0&id=21b32166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports